import React from "react";
import { DebounceInput } from "react-debounce-input";

const AdminReportFilters = ({
    filter = [],
    waves = [],
    packages = [],
    rsvpStatuses = [],
    handleFilter,
    ...props
}) => {
    return (
        <div className="row pt-2 pb-2">
            <div className="col-2">
                <label className="mt-2 ml-4 text-muted">FILTER</label>
            </div>
            <div className="col-10">
                <div className="row">
                    <div className="col-3">
                        <DebounceInput
                            onChange={handleFilter}
                            value={filter.name}
                            name="name"
                            className="form-control mr-4"
                            placeholder="Guest Name"
                        />
                    </div>
                    <div className="col-3">
                        <select
                            name="wave_id"
                            defaultValue={filter.wave_id}
                            onChange={(e) => handleFilter(e)}
                            className="form-control"
                        >
                            <option value={0}>Wave</option>

                            {waves.map((wave) => (
                                <option key={wave.id} value={wave.id}>
                                    {wave.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-3">
                        <select
                            name="package_id"
                            defaultValue={filter.package_id}
                            onChange={(e) => handleFilter(e)}
                            className="form-control"
                        >
                            <option value={0}>Package</option>

                            {packages.map((p) => (
                                <option key={p.id} value={p.id}>
                                    {p.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-3">
                        <select
                            name="rsvp_status"
                            defaultValue={filter.rsvp_status}
                            onChange={(e) => handleFilter(e)}
                            className="form-control"
                        >
                            <option value={0}>RSVP Status</option>

                            {rsvpStatuses.map((status) => (
                                <option key={status} value={status}>
                                    {status}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminReportFilters;
